import React, { useCallback, useState } from 'react'
import { Box, Icon } from '@maui/elements'

export const SortingToggle = ({
  children,
  columnName,
  isActive,
  canSort = true,
  isSortedDesc = true,
  sort = () => {}
}) => {
  const [descending, setDescending] = useState(isSortedDesc)
  const [currentHover, setCurrentHover] = useState(null)

  const handleClick = () => {
    sort(columnName, descending ? 'desc' : 'asc')
    setDescending(!descending)
  }

  return (
    <Box
      onClick={() => handleClick()}
      aria-label={canSort ? `Sort by ${columnName} ${descending ? '(desc)' : '(asc)'}` : `${columnName}`}
      cursor={canSort ? 'pointer' : 'default'}
      role='button'
      display='flex'
      flexDirection='row'
      alignItems='center'
      justifyContent='space-between'
      height={25}
      width='100%'
      onMouseEnter={() => setCurrentHover(columnName)}
      onMouseLeave={() => setCurrentHover(null)}
    >
      {children}
      {!canSort
        ? null
        : isActive
          ? <SortIcon isDesc={descending} />
          : <SortIcon isUnsorted={true} visibility={currentHover === columnName ? 'visible' : 'hidden'} />
      }
    </Box>
  )
}

export const SortIcon = ({ isUnsorted, isDesc, visibility = 'visible' }) => {
  const sortDirection = isUnsorted ? 'arrowsVertical' : isDesc ? 'arrowUp' : 'arrowDown'
  return (
    <Box display="flex" flexDirection="column" visibility={visibility} aria-label={`${sortDirection} icon`}>
      <Icon name={sortDirection} size="sm" />
    </Box>
  )
}

export const useSort = (defaultSortOrder = 'desc', defaultSortBy = []) => {
  const [sortBy, setSortBy] = useState(defaultSortBy)
  const [sortOrder, setSortOrder] = useState(defaultSortOrder)

  const onSortClick = useCallback(
    (sortBy) => {
      if (!sortBy) return
      const updatedSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
      setSortOrder(updatedSortOrder)
      setSortBy([sortBy])
    },
    [sortOrder, setSortOrder, setSortBy]
  )
  return { sortBy, sortOrder, onSortClick }
}
